<template>
  <div class="main_center">
      <el-card class="box-card">
          <div slot="header" class="clearfix">
              <span>数字见证</span>
          </div>
          <el-form ref="form" :model="form" class="form winnessRuleForm"  :rules='rules'>
              <el-form-item label="启用数字见证：" style="padding-bottom:10px;margin-bottom: 20px;">
                <el-switch
                        v-model="form.witnessType"
                        :active-value="1"
                        :inactive-value="0"
                        active-color="#13ce66"
                        inactive-color="#c0c0c0">
                </el-switch>
              </el-form-item>
              <el-form-item label="交易中心：" prop="tradeId">
                  <el-select v-model="form.tradeId" :disabled="disable"  clearable value-key="value" style="width:300px;">
                      <el-option v-for="(item,index) in transactionCenterList" :key="index" :label="item.orgName" :value="item.id"></el-option>
                  </el-select>
              </el-form-item>
              <p style="color:rgba(0, 0, 0, 0.85);font-size: 14px;">例外规则：</p>
              <el-form-item  prop='excluPremoney'>
                <el-checkbox :disabled="disable" v-model="form.excluPremoneyEnable">预算金额超
                  <!--  v-model="form.excluPremoney" -->
                  <el-input v-model="form.excluPremoney" style="width:100px" show-word-limit :disabled="disable"></el-input>
                  万的项目采用人工见证
                </el-checkbox>
              </el-form-item>
              <el-form-item>
                <el-checkbox v-model="form.excluImpprj" :disabled="disable">重点项目采用人工见证
                </el-checkbox>
              </el-form-item>
              <el-form-item prop='excluNewagenNum'>
                <el-checkbox :disabled="disable" v-model="form.excluNewagentEnable">新登记代理机构前
                  <el-input show-word-limit :disabled="disable" style="width:100px" v-model="form.excluNewagenNum"></el-input>
                  个项目采用人工见证
                </el-checkbox>
              </el-form-item>
              <el-button type="primary" style="margin:10px 0px;" @click="save()">保存</el-button>
              <el-divider></el-divider>
              <el-form-item label="以下项目将采用人工见证: " style="margin-top: 30px">
                <el-button size="mini" icon="el-icon-plus" type="primary" :disabled="disable" @click="addDeatil(1)">
                  新增
                </el-button>
              </el-form-item>
              <el-table :data="projectTableData" ref="multipleTable" stripe border>
                <el-table-column fixed label="序号" type="index" :index="indexMethod" width="50" align="center"
                                 :show-overflow-tooltip='true'></el-table-column>
                <el-table-column label="操作" align="center" width="100">
                  <template slot-scope="scope">
        <!--        <el-button type="text" title="修改" :disabled="disable"   @click="updateDetail(scope.row)">
                      修改
                    </el-button>-->
                    <el-button type="text" title="删除"  :disabled="disable" @click="deleteDetail(scope.row)">
                      删除
                    </el-button>
                  </template>
                </el-table-column>

                <el-table-column label="项目名称" prop='businessName' header-align="center" align="center" min-width='120'
                                 :show-overflow-tooltip='true'></el-table-column>
                <el-table-column label="项目编号" prop='businessCode' header-align="center" align="left" min-width='80'
                                 :show-overflow-tooltip='true'></el-table-column>
                <el-table-column label="项目类型" prop='busTypeName' header-align="center" align="center" min-width='100'
                                 :show-overflow-tooltip='true'></el-table-column>
              </el-table>
              <el-row style="margin-top: 20px;">
                <el-col :span="12">
                  <el-form-item label="以下代理机构代理的项目采用人工见证: ">
                    <el-button size="mini" icon="el-icon-plus" type="primary" :disabled="disable" @click="addDeatil(2)">
                      新增
                    </el-button>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-table :data="agentTableData" ref="multipleTable" stripe border>
                <el-table-column fixed label="序号" type="index" :index="indexMethod" width="50" align="center"
                                 :show-overflow-tooltip='true'></el-table-column>
                <el-table-column label="操作" align="center" width="100">
                  <template slot-scope="scope">
        <!--                <el-button type="text" title="修改" :disabled="disable"   @click="updateDetail(scope.row)">
                      修改
                    </el-button>-->
                    <el-button type="text" title="删除" :disabled="disable" @click="deleteDetail(scope.row)">
                      删除
                    </el-button>
                  </template>
                </el-table-column>

                <el-table-column label="代理机构名称" prop='businessName' header-align="center" align="center" min-width='120'
                                 :show-overflow-tooltip='true'></el-table-column>
                <el-table-column label="代理机构编号" prop='businessCode' header-align="center" align="left" min-width='80'
                                 :show-overflow-tooltip='true'></el-table-column>
              </el-table>

          </el-form>
      </el-card>

    <el-dialog title="新增采用人工见证的项目" :visible.sync="dialogVisibleProject" width="80%">
        <div class="dialogBox">
            <el-form ref="addDetailForm"
                     :model="addDetailForm"
                     :rules='detailrules'
                     label-width="180px"
                     class="form">
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="项目类型：" props="busType">
                            <el-select v-model="addDetailForm.busType" value-key="value" style="width:100%;"
                                       @change="selectBusTypeClick($event)">
                                <el-option v-for="(item,index) in businessTypeNamelist" :key="index"
                                           :label="item.name"
                                           :value="item.value"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12" style="display: none;">
                        <el-form-item label="id：" prop='id' style="width:100%;">
                            <el-input  v-model="addDetailForm.id" show-word-limit disabled></el-input>

                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="项目：" prop='businessName' style="width:100%;">
                            <!--                    <el-input maxlength="255"  v-model="addDetailForm.businessName" show-word-limit></el-input>-->
                            <select-prj-page
                                    :value.sync="businessName"
                                    :valueKey="'tenderProjectCode'"
                                    :labelKey="'businessName'"
                                    :columns="projectColumns"
                                    :dataList="projectList"
                                    @doSearchMethod="setProjectList"
                                    @onSelect="onSelectProjectData"
                            ></select-prj-page>
                        </el-form-item>
                    </el-col>
                    <!--                <el-col :span="12">
                                      <el-form-item label="项目编号：" prop='businessCode' style="width:100%;">
                                        <el-input maxlength="30"
                                                  v-model="addDetailForm.businessCode" show-word-limit></el-input>
                                      </el-form-item>
                                    </el-col>-->

                </el-row>

            </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" style="margin-bottom:20px;" @click="saveDetail(1)">保存</el-button>
          <el-button @click="cancelDialog()">返回</el-button>
      </span>
    </el-dialog>
    <el-dialog title="新增采用人工见证的代理机构" :visible.sync="dialogVisibleAgency" width="80%">
        <div class="dialogBox">
            <el-form ref="addDetailForm" :model="addDetailForm" :rules='detailrules' label-width="180px"
                     class="form">
                <el-row>
                    <el-col :span="12" style="display: none;">
                        <el-form-item label="id：" prop='id' style="width:100%;">
                            <el-input v-model="addDetailForm.id" show-word-limit disabled></el-input>
                        </el-form-item>
                    </el-col>
                    <!--                <el-col :span="12">
                                      <el-form-item label="代理机构编号：" prop='businessCode' style="width:100%;">
                                        <el-input maxlength="30"
                                                  v-model="addDetailForm.businessCode" show-word-limit></el-input>
                                      </el-form-item>
                                    </el-col>-->
                    <el-col :span="12">
                        <!--                  <el-form-item label="代理机构名称：" prop='businessName' style="width:100%;">
                                            <el-input maxlength="255"
                                                      v-model="addDetailForm.businessName" show-word-limit></el-input>
                                          </el-form-item>-->
                        <el-form-item label="代理机构：" prop='businessName' style="width:100%;">
                            <!--                         <el-input maxlength="255"  v-model="addDetailForm.businessName" show-word-limit></el-input>-->
                            <select-prj-page
                                    :value.sync="businessName"
                                    :valueKey="'tenderAgencyCode'"
                                    :labelKey="'businessName'"
                                    :columns="agencyColumns"
                                    :dataList="agencyList"
                                    @doSearchMethod="setAgencyList"
                                    @onSelect="onSelectAgencyData"
                            ></select-prj-page>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" style="margin-bottom:20px;" @click="saveDetail(2)">保存</el-button>
          <el-button @click="cancelDialog()">返回</el-button>
      </span>
    </el-dialog>

  </div>


</template>

<script>
    import {mapState} from "vuex";
    import selectPrjPage from '@/components/selectPage';
    import {isInteger} from "@/utils/validate";


    export default {
  components: {
    selectPrjPage,
  },
  data() {
    return {
      projectColumns: [{name: 'tenderProjectName', title: '项目名称'}, {name: 'tenderProjectCode', title: '项目编号'}],
      agencyColumns:[{name: 'tenderAgencyName', title: '代理机构名称'}, {name: 'tenderAgencyCode', title: '代理机构编号'}],
      projectList:[],
      agencyList:[],
      form: {
        id: '',
        witnessType: 0,
        excluPremoney: '',
        excluImpprj: false,
        excluPremoneyEnable: false,
        excluNewagentEnable: false,
        excluNewagenNum: '',
        tradeId: '', // 交易中心ID
      },
      rules: {
        excluPremoney: [{validator: isInteger, trigger: 'blur'}],
          excluNewagenNum: [{validator: isInteger, trigger: 'blur'}],
          tradeId: [ { required: true, message: '请选择交易中心', trigger: 'change' }],
      },
      moreSearchItem: false,
      checkList1: '',
      pageSize: 10,//每页条数
      pageIndex: 1,//当前页
      total: 0,//总条数
      projectTableData: [],
      agentTableData: [],
      multipleSelection: [],
      user: '', //角色类型
      formData: {},
      dialogVisibleProject: false,
      dialogVisibleAgency: false,
      //新增采用人工见证的xx form
      addDetailForm: {
        id:'',
        dataType: '',
        businessCode: '',
        businessName: '',
        busType: '',
        busTypeName:'',
        parentId: '',
      },
      detailrules: {
       /* businessCode: [{required: true, message: '请输入编号', trigger: 'blur'}, {
          validator: strLength_3,
          trigger: 'blur'
        }],*/
          busType: [{required: true, message: '请选择', trigger: 'blur'}],
          businessName: [{required: true, message: '请选择', trigger: 'blur'}],
      },
      canDetailAdd:false,
      businessTypeNamelist: [],
      transactionCenterList: [],
    }
  },
  computed: {
    ...mapState({
      stateData: state => state.user
    }),
      disable: {
          get() {
              return this.form.witnessType == 0?true:false
          },
      },
    businessName: {
      get() {
        return this.addDetailForm.businessName
      },
      set() {
      },
    },
  },
  filters: {
    ellipsis(text, num) {
      if (text.length > num) {
        return text.substring(0, num) + '...';
      } else {
        return text;
      }
    },
  },
    created() {
        this.getDic('jz_dgwitness_bustype');
        this.transactionCenterList = JSON.parse(sessionStorage.getItem("transactionCenterList"));
    },
    activated() {
    //this.user = this.stateData.pageRoleIds //角色类型
    this.getData();

  },
  mounted() {

  },
  methods: {


    indexMethod(index) {
      return (this.pageIndex - 1) * this.pageSize + index + 1
    },

    //招标项目
    setProjectList(pageInfo,callback){

        if(this.addDetailForm.busType == ''){
            this.$message.error("项目类型不能为空");
            return
        }

      this.$http.post('/tenderProject/getTenderProject',{
        'page': pageInfo.pageNo || 1,
        'rows': pageInfo.pageSize || 5,
        'searchKey':pageInfo.wordkey || '',
        'filter':{
            busType:this.addDetailForm.busType
        },
      }).then(res=>{
        this.projectList=res.data.rows;
        if(callback){
          callback(res.data.total);
        }
      })
    },

    //代理机构
    setAgencyList(pageInfo,callback){
      this.$http.post('/tenderProject/getTenderAgency',{
        'page': pageInfo.pageNo || 1,
        'rows': pageInfo.pageSize || 5,
        'searchKey':pageInfo.wordkey || '',
        'filter':{},
      }).then(res=>{
        this.agencyList=res.data.rows;
        if(callback){
          callback(res.data.total);
        }
      })
    },
    onSelectProjectData(val){
      let obj={};
      let filter = this.projectList.filter((item, index) => {
        return item.tenderProjectCode == val
      })
      if (filter && filter.length > 0) {
        obj = filter[0];
        this.addDetailForm.businessCode = obj.tenderProjectCode
        this.addDetailForm.businessName = obj.tenderProjectName
      } else {
        this.addDetailForm.businessCode = "";
        this.addDetailForm.businessName = "";
      }
    },

    onSelectAgencyData(val){
      let obj={};
      let filter = this.agencyList.filter((item, index) => {
        return item.tenderAgencyCode == val
      })
      if (filter && filter.length > 0) {
        obj = filter[0];
        this.addDetailForm.businessCode = obj.tenderAgencyCode
        this.addDetailForm.businessName = obj.tenderAgencyName
      } else {
        this.addDetailForm.businessCode = "";
        this.addDetailForm.businessName = "";
      }
    },

    getData() { // 获取列表数据
      this.$http.post('/witnessRuleConfig/getOne').then(res => {
        const data = res.data.data;
        this.form = {
          id: data.id,
          witnessType: data.witnessType,
          excluPremoney: data.excluPremoney,
          excluImpprj: data.excluImpprj == 1 ? true : false,
          excluPremoneyEnable: data.excluPremoneyEnable == 1 ? true : false,
          excluNewagentEnable: data.excluNewagentEnable == 1 ? true : false,
          excluNewagenNum: data.excluNewagenNum,
            tradeId: data.tradeId,
        }
        this.getDeatilList();
        this.form.id != '' && this.form.id !=undefined ? this.canDetailAdd = true : this.canDetailAdd = false;
      })
    },


    save() { //新增&保存

      this.$refs['form'].validate((valid) => {
          // debugger
        if (valid) {
          this.$http.post('/witnessRuleConfig/save',
              {
                id: this.form.id,
                witnessType: this.form.witnessType,
                excluPremoney: this.form.excluPremoney,
                excluImpprj: this.form.excluImpprj ? 1 : 0,
                excluPremoneyEnable: this.form.excluPremoneyEnable ? 1 : 0,
                excluNewagentEnable: this.form.excluNewagentEnable ? 1 : 0,
                  excluNewagenNum: this.form.excluNewagenNum,
                  tradeId: this.form.tradeId,
              }
          ).then(res => {
            if (res.data.code == '1') {
              this.getData();
              this.canDetailAdd=true;
              this.$message({
                type: 'success',
                message: res.data.msg
              })
            } else {
              this.$message({
                type: 'error',
                message: res.data.msg
              })
              this.errorData = res.data.data || {};
            }
          })

        }
      })
    },





    getDeatilList() { // 获取采用人工见证的xx列表数据
      console.log("this.form.id==>" + this.form.id);
      if (this.form.id != '' &&  this.form.id != undefined) {
        this.$http.post('/witnessRuleConfigDetail/list', {
          'page': this.pageIndex,
          'rows': this.pageSize,
          'filter': {
            parentId: this.form.id,
            dataType: 1,
          }
        }).then(res => {
          this.projectTableData = res.data.rows;
          this.total = res.data.total;
          this.$refs.multipleTable.doLayout()
        });
        this.$http.post('/witnessRuleConfigDetail/list', {
          'page': this.pageIndex,
          'rows': this.pageSize,
          'filter': {
            parentId: this.form.id,
            dataType: 2,
          }
        }).then(res => {
          this.agentTableData = res.data.rows;
          this.total = res.data.total;
          this.$refs.multipleTable.doLayout()
        });

      } else {
        this.projectTableData = [];
        this.agentTableData = [];
        this.total = 0;
      }
    },


    //新增采用人工见证的xx
    addDeatil(val) {
      if (this.canDetailAdd) {
        //弹出一个form窗口填写,保存
        switch (val) {
          case 1:
            this.dialogVisibleProject = true;
            break;
          case 2:
            this.dialogVisibleAgency = true;
            break;
        }
      } else {
        this.$message({
          type: 'error',
          message: "请先保存该见证规则设置!"
        })
      }
    },

    cancelDialog() { //新增采用人工见证的xx 返回
      this.dialogVisibleProject = false;
      this.dialogVisibleAgency = false;
      this.$refs['addDetailForm'].resetFields();
      this.addDetailForm.busType='';
      this.addDetailForm.businessCode = "";
      this.addDetailForm.businessName = "";
    },


    //保存 采用人工见证的xx
    saveDetail(val) {
      //dataType=1,新增采用人工见证的项目
      //dataType=2,新增采用人工见证的代理机构代理
      this.addDetailForm.dataType = val;
      console.log("parentId==>" + this.form.id)
      this.addDetailForm.parentId = this.form.id;

      console.log("******addDetailForm=>id:"+this.addDetailForm.id)

      this.$refs['addDetailForm'].validate((valid) => {
        if (valid) {
          this.$http.post('/witnessRuleConfigDetail/save', this.addDetailForm).then(res => {

            this.cancelDialog();

            if (res.data.code == 1) {
              this.$message({
                type: 'success',
                message: res.data.msg
              })
              this.getDeatilList()
            } else {
              this.$message({
                type: 'error',
                message: res.data.msg
              })
              this.errorData = res.data.data || {};
            }
          })

        }
      })

    },

    deleteDetail(item) {
      this.$confirm(`确定要删除该数据?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http.post('/witnessRuleConfigDetail/delete', {
          id: item.id
        }).then(res => {
          if (res.data.code == '1') {
            this.$message({
              type: 'success',
              message: res.data.msg
            })
            this.getDeatilList();
          } else {
            this.$message({
              type: 'error',
              message: res.data.msg
            })
          }
        })
      })
    },


    getDeatilById(id) { //根据id获取见证规则配置附表
      if (id != "") {
        this.$http.get('/witnessRuleConfigDetail/get?id=' + id).then(res => {
          if (res.data.code == '1') {
            const data = res.data.data
            this.addDetailForm = data;
          }
        })
      } else {
        //  新增
        this.$refs['addDetailForm'].resetFields();
      }
    },


    /*updateDetail(item) { // 修改该见证规则配置附表
      var id = item.id;
      console.log("id-->" + id);
      this.addDeatil(item.dataType);
      this.getDeatilById(id);
    },*/

    selectBusTypeClick(val) {
      this.businessTypeNamelist.forEach((item, index) => {
        if (item.value == val) {
          this.addDetailForm.busTypeName = item.name
        }
      });
    },

    getDic(type) { // 获取字典
      this.$http.get('/sys/dictData/getList?type=' + type).then(res => {
        if (res.data.code === '1') {
          switch (type) {
            case 'jz_dgwitness_bustype':
              this.businessTypeNamelist = res.data.data;
              break;
          }
        }
      })
    },

  }


}
</script>

<style lang="less">
.main_center {


  .winnessRuleForm{
    .el-form-item{
      margin-bottom: 20px;
        .el-form-item__content{
            float: left;
        }
    }
  }

  .top {
    .input_title {
      display: flex;
    }

    .el-form-item {
      margin-bottom: 0;
    }
  }
}

.margin-hide {
  .el-form-item__content {
    margin-left: 0 !important;
  }
}
</style>